import React from "react";

const PageLayout = ({ title, desc, children }) => {
  return (
    <div className="page-container">
      <div className="page-hero">
        <h1>{title}</h1>
        <p>{desc}</p>
      </div>

      <div className="page-content container">{children}</div>
    </div>
  );
};

export default PageLayout;
